const strings = {
  titleModal: 'Novo contato',
}

export default strings
